module.exports = __webpack_public_path__ + "img/keyboard_backspace.9ff69215.svg";